import moment from "moment";
import { useCallback, useEffect, useState } from "react";
import {
  convertToCents,
  formatCurrency,
} from "../../../Utils/formatters";
import { Button } from "../../Atoms";
import { InputMoney } from "../../Atoms/InputMoney";
import { ScreenGreeting, PasswordConfirm } from "../../Molecules";
import { DataContent, DetailsGrid, Actions } from "./styles";
import { useToast } from "../../../Hooks/toast";
import CancelOutlined from "@mui/icons-material/CancelOutlined";
import PaymentRounded from "@mui/icons-material/PaymentRounded";

export const PixPreview = ({
  isCustomValue,
  previewData,
  finishTransaction,
  cancelOperation,
  isLoading,
}) => {
  const [amountValue, setAmountValue] = useState(0);
  const [requirePassword, setRequirePassword] = useState(false);
  const { addToast } = useToast();
  const [document, setDocument] = useState(true);

  useEffect(() => {
    let doc = "";
    if (previewData?.receiver.document) {
      const digitsOnly = String(previewData.receiver.document).replace(/\D/g, "");

      if (digitsOnly.length >= 14) {
        doc = "••" + digitsOnly.slice(2, 16) + "••";
      } else if (digitsOnly.length >= 9) {
        doc = "•••" + digitsOnly.slice(3, 12) + "••";
      } else {
        doc = "•••" + digitsOnly + "••";
      }

      setDocument(doc);
    }
  }, [previewData]);

  const handleConfirmPixPayment = useCallback(
    (pass) => {
      if (amountValue <= 0 && previewData.amount <= 0) {
        addToast({
          title: "Adicione um valor!",
          type: "error",
          description: "Não se esqueça de adicionar um valor à transação.",
        });
        return;
      }
      let payload = {
        validation: {
          password_combination: pass,
        },

        amount: isCustomValue
          ? convertToCents(amountValue)
          : previewData.amount,
        pix_id: previewData?.pix_id,
        documentToValidate:previewData.documentToValidate
      };
console.log("payload",payload);
      finishTransaction(payload);
      setRequirePassword(false);
    },
    [previewData, amountValue]
  );

  return (
    <>
      <ScreenGreeting
        title={"Transferência Pix"}
        subTitle={
          "Confirme os dados do benefeciado antes de confirmar o pagamento."
        }
      />
      <DataContent style={{ marginTop: 0, paddingTop: 0 }}>
        <p>Valor da transferência</p>

        {isCustomValue ? (
          <InputMoney
            style={{ marginTop: 0, paddingTop: 0 }}
            hasInput={false}
            refreshValue={(value) => {
              setAmountValue(value);
            }}
          />
        ) : (
          <h3>{formatCurrency(previewData.amount)}</h3>
        )}
        <hr />

        <DetailsGrid>
          <p>Pagamento para</p>
          <span>{previewData?.receiver.name}</span>

          <p>CPF</p>
          <span>{document}</span>

          <p>Identificador</p>
          <span>{previewData?.pix_id}</span>

          <p>Banco</p>
          <span>{previewData?.receiver.bank_name}</span>

          <p>Data</p>
          <span>{moment().format("DD/MM/YYYY")}</span>

          {previewData?.documentToValidate !== "" &&
          previewData?.documentToValidate != null && (
            <>
              <p>Documento para validação</p>
              <span>{previewData?.documentToValidate}</span>
            </>
          )}
        </DetailsGrid>

        <hr />
        <Actions>
          <Button
            action={"cancel"}
            onClick={cancelOperation}
            disabled={isLoading}
            style={{ height: 44, padding: "0 24px", fontSize: 16, minWidth: 140 }}
          >
            <CancelOutlined fontSize="small" />
            Cancelar
          </Button>
          <Button
            disabled={isLoading}
            onClick={() => {
              setRequirePassword(true);
            }}
            style={{ height: 44, padding: "0 24px", fontSize: 16, minWidth: 140 }}
          >
            <PaymentRounded fontSize="small" />
            TRANSFERIR
          </Button>
        </Actions>
      </DataContent>
      <PasswordConfirm
        submitPassword={(e) => handleConfirmPixPayment(e)}
        open={requirePassword}
        onClose={() => setRequirePassword(false)}
      />
    </>
  );
};
